/* eslint-disable jsx-a11y/anchor-is-valid */
import {FC, useEffect, useState} from 'react'
import {Column} from 'react-table'
import {KTCard} from '../../../../../../../../_metronic/helpers'
import {KTable, KTableHeader, KTableLoading} from '../../../../../../components/UI'
import {KTableProvider, useKTable} from '../../../../../../contexts/KTableProvider'
import {useHoteleria} from '../../../../../../hooks/useHoteleria'
import {BillingDocument} from '../../../../models/billing.model'
import {
  getListBillingDetailCSVService,
  getListBillingDetailExcelService,
  getListBillingDetailPDFService,
  getListBillingDetailService,
} from '../../../../services/billing.service'
import moment from 'moment'
import {getSnackBar, getSnackBarToast} from '../../../../../../util/snackBar'

const TableReportFacturationSubDetail: FC = () => {
  const {data, setData, setPagination, loading, setLoading, pagination} = useKTable()
  const {currentTabItem, isAllowed} = useHoteleria()
  const [isDownloadXLS, setIsDownloadXLS] = useState<boolean>(false)
  const [isDownloadCSV, setIsDownloadCSV] = useState<boolean>(false)
  const [isDownloadPDF, setIsDownloadPDF] = useState<boolean>(false)

  const getDetailFacturation = async () => {
    try {
      setLoading(true)
      const {data: response} = await getListBillingDetailService(
        currentTabItem.idToEdit as any,
        pagination.currentPage,
        pagination.perPage,
      )
      if (!response.error) {
        setData(response.data)
        setPagination({
          ...pagination,
          totalResults: response.total,
        })
      }
      setLoading(false)
    } catch (error) {
      setLoading(false)
    }
  }

  const handleExportXLS = async () => {
    try {
      setIsDownloadXLS(true)
      const response = await getListBillingDetailExcelService(currentTabItem.idToEdit)
      const blob = new Blob([response.data], {
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      })
      // Crea un enlace temporal y simula un clic para descargar el archivo
      moment().format('DD/MM/YY HH:mm').toString()
      const link = document.createElement('a')
      link.href = window.URL.createObjectURL(blob)
      link.download = `Reporte de Facturacion_Detalle-${moment()
        .format('DD/MM/YY HH:mm')
        .toString()}.xlsx`
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
      setIsDownloadXLS(false)
      getSnackBarToast('Se descargó el documento con éxito', 'success')
    } catch (error) {
      setIsDownloadXLS(false)
      getSnackBarToast('Hubo un error al descargar', 'error')
    }
  }
  const handleExportCSV = async () => {
    try {
      setIsDownloadCSV(true)
      const response = await getListBillingDetailCSVService(currentTabItem.idToEdit)
      const blob = new Blob([response.data], {
        type: 'text/csv',
      })
      // Crea un enlace temporal y simula un clic para descargar el archivo
      moment().format('DD/MM/YY HH:mm').toString()
      const link = document.createElement('a')
      link.href = window.URL.createObjectURL(blob)
      link.download = `Reporte de Facturacion_Detalle-${moment()
        .format('DD/MM/YY HH:mm')
        .toString()}.csv`
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
      getSnackBarToast('Se descargó el documento con éxito', 'success')
      setIsDownloadCSV(false)
    } catch (error) {
      setIsDownloadCSV(false)
      getSnackBarToast('Hubo un error al descargar', 'error')
      //
    }
  }
  const handleExportPDF = async () => {
    try {
      setIsDownloadPDF(true)
      const response = await getListBillingDetailPDFService(currentTabItem.idToEdit)
      const blob = new Blob([response.data], {
        type: 'application/pdf',
      })
      // Crea un enlace temporal y simula un clic para descargar el archivo
      moment().format('DD/MM/YY HH:mm').toString()
      const link = document.createElement('a')
      link.href = window.URL.createObjectURL(blob)
      link.download = `Reporte de Facturacion_Detalle-${moment()
        .format('DD/MM/YY HH:mm')
        .toString()}.pdf`
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
      setIsDownloadPDF(false)
      getSnackBarToast('Se descargó el documento con éxito', 'success')
    } catch (error) {
      setIsDownloadPDF(false)
      getSnackBarToast('Hubo un error al descargar', 'error')
    }
  }

  useEffect(() => {
    getDetailFacturation()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pagination.currentPage])

  useEffect(() => {
    getDetailFacturation()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentTabItem.idToEdit])

  const columns: Column<BillingDocument>[] = [
    {
      Header: (props) => <KTableHeader tableProps={props} title='Nro Reserva' />,
      accessor: 'NroReserva',
    },
    {
      Header: (props) => <KTableHeader tableProps={props} title='Fecha Estadía' />,
      accessor: 'FechaEstadia',
    },
    {
      Header: (props) => <KTableHeader tableProps={props} title='Empresa' />,
      accessor: 'HuespedEmpresa',
    },
    {
      Header: (props) => <KTableHeader tableProps={props} title='Empresa Contratante' />,
      accessor: 'HuespedEmpresaContratante',
    },
    {
      Header: (props) => <KTableHeader tableProps={props} title='Cliente' />,
      accessor: 'Cliente_descripcion',
    },
    {
      Header: (props) => <KTableHeader tableProps={props} title='Campamento' />,
      accessor: 'Campamento_descripcion',
    },
    {
      Header: (props) => <KTableHeader tableProps={props} title='Nomenclatura de Módulo' />,
      accessor: 'Modulo_descripcion',
    },
    {
      Header: (props) => <KTableHeader tableProps={props} title='Tipo de Habitación' />,
      accessor: 'TipoHabitacion_descripcion',
    },
    {
      Header: (props) => <KTableHeader tableProps={props} title='Nomenclatura de Habitación' />,
      accessor: 'Habitacion_descripcion',
    },
    {
      Header: (props) => <KTableHeader tableProps={props} title='Nomenclatura de Cama' />,
      accessor: 'Cama_descripcion',
    },
    {
      Header: (props) => <KTableHeader tableProps={props} title='Tipo Doc. Principal' />,
      accessor: 'TipoDocPrincipal',
    },
    {
      Header: (props) => <KTableHeader tableProps={props} title='Nro Doc. Principal' />,
      accessor: 'HuespedDni',
    },
    {
      Header: (props) => <KTableHeader tableProps={props} title='Fotocheck' />,
      accessor: 'HuespedFotocheck',
    },
    {
      Header: (props) => <KTableHeader tableProps={props} title='Nombres' />,
      accessor: 'HuespedNombres',
    },
    {
      Header: (props) => <KTableHeader tableProps={props} title='Apellidos' />,
      accessor: 'HuespedApellidos',
    },
    {
      Header: (props) => <KTableHeader tableProps={props} title='Centro de Costos' />,
      accessor: 'CentroCostos',
    },
    {
      Header: (props) => <KTableHeader tableProps={props} title='Costo' />,
      accessor: 'Costo',
    },
    {
      Header: (props) => <KTableHeader tableProps={props} title='Fecha CheckIn' />,
      accessor: 'FechaCheckIn',
    },
    {
      Header: (props) => <KTableHeader tableProps={props} title='Fecha CheckOut' />,
      accessor: 'FechaCheckOut',
    },
  ]

  useEffect(() => {
    setLoading(loading)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [loading])

  return (
    <>
      <KTCard shadow className='m-5'>
        {isAllowed('TABLAFACTURACION/EXPORTAR') && (
          <div className='d-flex justify-content-end p-2 me-5'>
            <button
              type='button'
              className='btn btn-success me-3 d-flex align-items-center'
              onClick={handleExportPDF}
              disabled={isDownloadPDF}
            >
              {isDownloadPDF && (
                <div className='icon-container me-3'>
                  <i className='loader'></i>
                </div>
              )}
              Exportar PDF
            </button>
            <button
              type='button'
              className='btn btn-success me-3 d-flex align-items-center'
              onClick={handleExportXLS}
              disabled={isDownloadXLS}
            >
              {isDownloadXLS && (
                <div className='icon-container me-3'>
                  <i className='loader'></i>
                </div>
              )}
              Exportar XLSX
            </button>
            <button
              type='button'
              className='btn btn-success me-3 d-flex align-items-center'
              onClick={handleExportCSV}
              disabled={isDownloadCSV}
            >
              {isDownloadCSV && (
                <div className='icon-container me-3'>
                  <i className='loader'></i>
                </div>
              )}
              Exportar CSV
            </button>
          </div>
        )}

        <KTable data={data} columns={columns as any} />
        {loading ? <KTableLoading title='Cargando...' /> : null}
      </KTCard>
    </>
  )
}

const TableReportFacturationSubDetailWrapper = () => {
  const {isAllowed} = useHoteleria()
  return (
    <KTableProvider>
      {isAllowed('TABLAFACTURACION/LISTAR') && <TableReportFacturationSubDetail />}
    </KTableProvider>
  )
}
export {TableReportFacturationSubDetailWrapper}
